<template>
  <div class="page--search">
    <div class="container">
      <GTopAds />
      <h2 v-if="screen.isDesktop" class="text-search-result">
        <span class="">Search Result</span>
      </h2>
      <p v-if="tagName && screen.isDesktop" class="text-search-result-para">
        Hasil pencarian dengan kata kunci
        <span>"{{ tagName }}"</span>
      </p>

      <p v-if="!tagName" class="text-search-result-para">
        <span
          v-if="
            (lists && lists.length) ||
            (resultOfBrand &&
              resultOfBrand.length &&
              exactSearch &&
              (exactSearch.product || exactSearch.brand) &&
              isShowAnyResult)
          "
          >Hasil pencarian dengan kata kunci <b>"{{ query }}"</b></span
        >
        <span v-else-if="!exactSearch.product && !exactSearch.brand && isShowAnyResult"
          >Produk dan brand dengan kata kunci <b>"{{ query }}"</b> tidak ditemukan. Menampilkan hasil pencarian yang
          terdekat dengan kata kunci.</span
        >
        <span v-else
          >Hasil pencarian dengan kata kunci <b>"{{ query }}"</b> tidak ditemukan.</span
        >
      </p>

      <div class="row">
        <div class="col-md-9 col-xs-12 col0">
          <div v-if="screen.isDesktop" class="col-xs-12 col0 left-side hidden-sm hidden-xs">
            <div class="section__filter based-column w-100">
              <template v-if="!isLoadingFinishSearchFilterBrand">
                <div style="background-color: #ffffff; border-radius: 4px">
                  <ProductFilterLoader />
                </div>
              </template>
              <template v-else>
                <div class="filter-group filter-group--by-brand">
                  <h4 class="filter-group__heading">Availibility</h4>
                  <ul class="list">
                    <li v-for="(avail, idx) in availibility" :key="idx" class="list__item">
                      <input
                        :id="avail"
                        v-model="filterAvailChecked"
                        type="checkbox"
                        name="filter_brand_desktop"
                        :value="avail"
                        class="checkbox"
                      />
                      <label>{{ `Available at ${avail == 'sociolla' ? 'Sociolla' : 'Lilla'}` }}</label>
                    </li>
                  </ul>
                </div>

                <div class="filter-group filter-group--by-brand">
                  <h4 class="filter-group__heading">Brands</h4>
                  <div class="input-search-header">
                    <input
                      v-model="searchText"
                      type="text"
                      placeholder="Search..."
                      name="search_text_desktop"
                      class="form-control"
                      @keyup="searchingOnFilterBrand(searchText)"
                    />
                  </div>
                  <div>
                    <ul class="list-inline">
                      <li v-for="(brand, key) in selectedBrandList" :key="key">
                        <div class="pill">
                          {{ activeTab === 0 ? brand.name : brand.country }}
                          <span class="pill-dismiss" @click.self.prevent="removeSelectedBrand(key)"></span>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <ul class="list">
                    <li v-for="(brand, key) in brands" :key="key" class="list__item">
                      <input
                        v-if="activeTab === 0"
                        :id="`brandFilter${key}`"
                        v-model="filterBrandChecked"
                        type="checkbox"
                        name="filter_brand_desktop"
                        :value="`${brand['_id']}`"
                        class="checkbox"
                      />
                      <input
                        v-else
                        :id="`brandFilter${key}`"
                        v-model="filterOriginChecked"
                        type="checkbox"
                        name="filter_brand_desktop"
                        :value="`${brand['country_tag_id']}`"
                        class="checkbox"
                      />
                      <label :for="`brandFilter${key}`">
                        <img v-if="activeTab === 1" :src="brand.flag" class="flag-origin" />
                        {{ activeTab === 0 ? brand.name.charAt(0).toUpperCase() + brand.name.slice(1) : brand.country }}
                      </label>
                    </li>
                    <li v-if="!brands.length">No Results Found</li>
                  </ul>
                </div>

                <div class="filter-group filter-group--by-rating">
                  <h4 class="filter-group__heading">Ratings</h4>
                  <ul class="list">
                    <li class="list__item">
                      <label class="radio-donut">
                        <input v-model="filterRating" type="radio" name="rating_desktop" value="all ratings" checked />
                        All Ratings
                        <span></span>
                      </label>
                    </li>
                    <li class="list__item">
                      <label class="radio-donut">
                        <input v-model="filterRating" type="radio" name="rating_desktop" value="5" />
                        <GRatingInline average-rating="5.0" star-fill-number="50" />
                        <span></span>
                      </label>
                    </li>
                    <li class="list__item">
                      <label class="radio-donut">
                        <input v-model="filterRating" type="radio" name="rating_desktop" value="4" />
                        <GRatingInline average-rating="4" star-fill-number="40" />
                        <span></span>
                      </label>
                    </li>
                    <li class="list__item">
                      <label class="radio-donut">
                        <input v-model="filterRating" type="radio" name="rating_desktop" value="3" />
                        <GRatingInline average-rating="3.0" star-fill-number="30" />
                        <span></span>
                      </label>
                    </li>
                    <li class="list__item">
                      <label class="radio-donut">
                        <input v-model="filterRating" type="radio" name="rating_desktop" value="2" />
                        <GRatingInline average-rating="2.0" star-fill-number="20" />
                        <span></span>
                      </label>
                    </li>
                    <li class="list__item">
                      <label class="radio-donut">
                        <input v-model="filterRating" type="radio" name="rating_desktop" value="1" />
                        <GRatingInline average-rating="1.0" star-fill-number="10" />
                        <span></span>
                      </label>
                    </li>
                  </ul>
                </div>

                <div class="group-btn">
                  <button type="button" class="btn btn_white mr-15" @click.prevent="resetFilter">Reset</button>
                  <button type="button" class="btn btn--black" @click.prevent="applyFilters">Apply</button>
                </div>
              </template>
            </div>
          </div>
          <div class="col-xs-12 col0 right-side">
            <div
              v-if="
                !tagName &&
                trendingSearchData &&
                Array.isArray(trendingSearchData) &&
                trendingSearchData.length > 0 &&
                resultOfBrand &&
                Array.isArray(resultOfBrand) &&
                resultOfBrand.length === 0 &&
                lists &&
                Array.isArray(lists) &&
                lists.length === 0
              "
              class="section trending-search section--brand"
            >
              <div>
                <div>
                  <div class="section__head">
                    <h4 class="section__heading">Trending Search</h4>
                  </div>

                  <div class="section__body">
                    <ul ref="list-trending-search--result" class="list-scrollable list-recently-search">
                      <li v-for="(trending, key) in trendingSearchData" :key="`list-trending-search--result${key}`">
                        <router-link :to="`/search?query=${trending}`" class="pill pill__tags">
                          <img src="/assets/img/popular.svg" alt="Popular" class="tag-icon" />
                          {{ trending }}
                        </router-link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div
              v-if="
                (!tagName && resultOfBrand && resultOfBrand.length && isLoadingFinishSearchBrand) ||
                !isLoadingFinishSearchBrand
              "
              class="section section--brand"
            >
              <div class="section__head" :style="{ ...(!isLoadingFinishSearchBrand && { borderBottom: 'none' }) }">
                <template v-if="!isLoadingFinishSearchBrand">
                  <GFMP :styles="{ ...fmpStyles.rounded, width: '96px' }" />
                </template>
                <template v-else>
                  <h4 class="section__heading">Popular Brand</h4>
                  <h6 class="section__total-found">{{ resultOfBrand.length }} Brands found</h6>
                </template>

                <div class="section__body">
                  <ul class="list-brand list-scrollable">
                    <li v-for="(brand, key) in isLoadingFinishSearchBrand ? resultOfBrand : []" :key="key">
                      <GFMP
                        v-if="!isLoadingFinishSearchBrand"
                        :styles="{ ...fmpStyles.rounded, width: '100%', height: '64px' }"
                      />
                      <router-link v-else :to="`/brand/${brand.my_soco_sql_id}/${$options.filters.slug(brand.name)}`">
                        <img
                          v-if="brand.logo"
                          :src="mainImage(brand.logo)"
                          class="list-brand__img"
                          onerror="this.src='/assets/img/default_img_brand.svg'"
                          alt="SOCO"
                        />
                        <img v-else src="/assets/img/default_img_brand.svg" class="list-brand__img" alt="SOCO" />
                      </router-link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <!-- NO RESULT ON QUERY-->
            <div v-if="!isShowAnyResult" class="section section--brand">
              <div v-if="isLoadingFinishSearchBrand">
                <div v-if="exclusiveAndTrendingTabs[onTab] && exclusiveAndTrendingTabs[onTab].brands.length">
                  <div class="section__head">
                    <h4 class="section__heading">Popular Brand</h4>
                  </div>

                  <div class="section__body">
                    <ul class="list-brand list-scrollable">
                      <li v-for="(brand, key) in exclusiveAndTrendingTabs[onTab].brands" :key="key">
                        <router-link :to="`/brand/${brand.my_soco_sql_id}/${$options.filters.slug(brand.name)}`">
                          <img
                            v-if="brand.logo"
                            :src="brand.logo"
                            class="list-brand__img"
                            onerror="this.src='/assets/img/default_img_brand.svg'"
                            alt="SOCO"
                          />
                          <img v-else src="/assets/img/default_img_brand.svg" class="list-brand__img" alt="SOCO" />
                        </router-link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div class="section section-sort">
              <div v-if="!isShowAnyResult">
                <h4 class="section__heading">Popular Product</h4>
              </div>
              <div v-else>
                <h4 class="section__heading">Product</h4>
              </div>
              <ListSortProduct
                :list-left-mobile="[]"
                :default-sort="'relevan'"
                :product-count="lists_count"
                @filtered="filtered"
              />
            </div>
            <div class="section section--result-product">
              <div v-if="isLoadingFinishSearchProduct">
                <div v-if="lists.length || isUserUsingFilter">
                  <div class="section__body pt-0">
                    <div class="section__listing based-column w-100">
                      <div v-if="lists.length" class="row search-list-pro">
                        <div v-for="(product, key) in lists" :key="key" class="col-xs-6 col-md-4 col-product">
                          <GProduct
                            :key="key"
                            class="product-wrapper"
                            :button-review="true"
                            :product="product"
                            :inline-reviewers="true"
                            :section="`search`"
                            @updatedProduct="setUpdatedProduct"
                          />
                        </div>
                      </div>
                      <div
                        v-else-if="isValidQuery"
                        class="section__head empty-result review-detail"
                        style="background-color: #ffffff"
                      >
                        <div class="no-result-found">
                          <div class="no-result-found--image">
                            <SvgImg class="lazy-img" name="product-not-found" width="72" height="65" />
                          </div>
                          <p class="no-result-found--text">Sorry dear, no suggestion found</p>
                          <p class="no-result-found--subtext">We cant find any brand & product matching your search</p>
                          <button class="btn btn-black center-block" @click.prevent="resetFilter">Reset filter</button>
                        </div>
                      </div>
                      <div v-else class="row search-list-pro">
                        <div
                          v-for="(product, key) in exclusiveAndTrendingTabs[onTab].products"
                          :key="key"
                          class="col-xs-6 col-md-4 col-product"
                        >
                          <GProduct
                            :key="key"
                            class="product-wrapper"
                            :button-review="true"
                            :product="product"
                            :inline-reviewers="true"
                            :section="`search`"
                            @updatedProduct="setUpdatedProduct"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <!-- NO RESULT FOUND -->
                  <div class="no-result-found">
                    <div class="no-result-found--image">
                      <SvgImg class="lazy-img" name="product-not-found" width="72" height="65" />
                    </div>
                    <p class="no-result-found--text">Sorry dear, no suggestion found</p>
                    <p class="no-result-found--subtext">We cant find any brand & product matching your search</p>
                    <button class="btn btn-black center-block" @click.prevent="resetFilter">Reset filter</button>
                  </div>
                </div>
              </div>
              <div v-else class="section__body" style="padding: 0 15px">
                <div class="row" style="margin-bottom: 20px">
                  <div v-for="i in 2" :key="i" class="col-xs-12" style="margin-bottom: 16px">
                    <GFMP
                      :key="`FMP_PRODUCT-LONG_${i}`"
                      :styles="{ ...fmpStyles.rounded, width: `${100 - i * 20}%` }"
                    />
                  </div>
                </div>

                <div class="row">
                  <div v-for="i in 12" :key="i" class="col-xs-6 col-md-3 col-product" style="width: 33.3%">
                    <ProductCardLoader :key="`FMP_PRODUCT_${i}`" />
                  </div>
                </div>
              </div>
            </div>
            <div v-if="isLoadingFinishSearchProduct && lists_count > limitForProduct" class="section-pagination">
              <Pagination
                key="Pagination"
                ref="paginationProduct"
                :limit="limitForProduct"
                :skip="skipForProduct"
                :total-item="lists_count"
                @skipTo="skipTo"
              />
            </div>
          </div>

          <div
            v-if="trendingProducts.length"
            class="trending trending-review section hidden-lg hidden-md hidden-xs hidden-sm"
          >
            <h3 class="section-heading">Trending Products</h3>
            <ListProductSlide
              key="trendingProducts"
              class-modifier="trending--products"
              :products="trendingProducts"
              :is-loading-finish="isLoadingFinishTrendingProducts"
              object_type="trending_products"
            />
          </div>
        </div>

        <div class="col-md-3 hidden-xs hidden-sm">
          <ProductInlineListLoader v-if="isLoadingFinishTrendingProducts" />
          <div v-else>
            <div v-if="trendingProducts.length" class="trending-product">
              <h2 class="trending-product__heading">Trending Products</h2>
              <router-link
                v-for="(product, key) in trendingProducts"
                :key="`popular-product-${key}`"
                :to="$options.filters.productUrlReview(product)"
                :title="product.name"
                @click.native="trackProduct(product)"
              >
                <div class="card-container">
                  <div class="card">
                    <div class="image-container">
                      <img class="image" :src="imageCover(product)" alt="product_trending_image" />
                    </div>
                    <div class="details">
                      <div class="title">{{ product.brand.name }}</div>
                      <div class="subtitle">{{ product.name }}</div>
                      <div class="rating">
                        <div class="stars">
                          <span
                            v-for="starIndex in 5"
                            :key="`star-${starIndex}`"
                            :class="[starIndex <= averageRating(product) ? 'star' : 'star-empty']"
                          >
                            &#9733;
                          </span>
                        </div>
                        <div class="rating-value">{{ product.review_stats.average_rating.toFixed(1) }}</div>
                        <div class="reviews">
                          ({{ $options.filters.cnvrtNumberToK(product.review_stats.total_reviews) }})
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </router-link>
            </div>
          </div>

          <div style="padding-top: 16px">
            <AddThoughts
              key="AddThoughts"
              button-text="Write review"
              button-redirect-url="/review/add"
              copywriting="Ingin berkontribusi menambah review dengan konten yang menarik?"
            />
          </div>
        </div>
      </div>

      <div v-if="!screen.isDesktop">
        <ModalFilterSearch
          v-if="showModalFilterSearch"
          :list_brands="brands"
          :list_country="brandscountry"
          :options="{ available: true, brands: true, rating: true }"
        />

        <div
          v-if="!screen.isDesktop"
          class="filter-product"
          :class="{
            'filter-product--active': 0,
            'filter-product--disabled': 0,
          }"
          @click.prevent="showModal"
        >
          <img
            v-if="isFiltered"
            src="/assets/img/icon-filter-revamp-active.svg"
            width="15"
            height="11"
            class="filter-product__img"
            alt="Filter icon"
          />
          <img
            v-else
            src="/assets/img/icon-filter-revamp.svg"
            class="filter-product__img"
            width="17"
            height="18"
            alt="Filter icon"
          />
          <span class="filter-product__text">Filter{{ Object.keys($route.query).length ? '' : '' }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const Config = require('~/config/default.env').default;

export default {
  name: 'my-search',
  components: {
    AddThoughts: () => import('@/components/global/add-thoughts/add-thoughts'),
    Pagination: () => import('@/components/global/pagination/pagination'),
    ListProductSlide: () => import('@/components/dashboard/snippet/list-product-slide'),
    ModalFilterSearch: () => import('@/components/global/modal/modal-filter-search'),
    ListSortProduct: () => import('@/components/global/list-sort-product/list-sort-product'),
    ProductFilterLoader: () => import('@/components/global/loader/product-filter-loader'),
    ProductCardLoader: () => import('@/components/global/loader/product-card-loader'),
    ProductInlineListLoader: () => import('@/components/global/loader/product-inline-list-loader'),
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('setListProducts', []);
    next();
  },
  data() {
    return {
      brands: '',
      brandscountry: '',
      dropdownToggleText: 'relevan',
      filterName: 'name',
      filterCreated: 'newest',
      filterRatingss: 'rating',
      filterBrandChecked: [],
      filterOriginChecked: [],
      filterAvailChecked: [],
      availibility: ['sociolla', 'lulla'],
      filterRating: 'all ratings',
      isLoadingFinishTrendingProducts: true,
      isLoadingFinishSearchBrand: false,
      isLoadingFinishSearchProduct: false,
      isLoadingFinishSearchFilterBrand: false,
      limitForProduct: 12,
      limitForBrand: 10,
      resultOfBrand: [],
      // resultOfProduct: [],
      searchBrandFilter: '',
      skipForProduct: 0,
      skipForBrand: 0,
      sortProduct: '',
      totalResultOfBrand: 0,
      totalResultOfProduct: 0,
      trendingProducts: [],
      isScroll: false,
      scrollTop: 0,
      searchText: '',
      queryString: {
        query: '',
        sortby: '',
        brand: '',
        origins: '',
        filter_rating: '',
        page: 1,
        available_for: '',
      },
      activeTab: 0,
      vowelsArray: ['a', 'i', 'u', 'e', 'o'],
      onTab: 'trending',
      fmpStyles: {
        rounded: {
          borderRadius: '8px',
          height: '16px',
        },
        circle: {
          borderRadius: '50%',
          height: '12px',
        },
      },
    };
  },
  computed: {
    showModalFilterSearch() {
      return this.$store.state.modal.isModalShow.filterSearch;
    },
    query() {
      return this.$route.query.query;
    },
    queryBrandId() {
      return this.$route.query.brand;
    },
    queryOriginId() {
      return this.$route.query.origins;
    },
    queryPage() {
      return this.$route.query.page ? this.$route.query.page : 1;
    },
    querySorting() {
      if (this.$route.query.sortby) {
        return this.$route.query.sortby;
      } else {
        return 'relevan';
      }
    },
    queryRating() {
      return this.$route.query.filter_rating;
    },
    screen() {
      return this.$store.state.screen;
    },
    isUserUsingFilter() {
      return Boolean(this.queryBrandId || this.queryOriginId || this.queryRating || this.filterRating);
    },
    copywritingFilterName() {
      if (this.filterName === 'name') {
        return 'A - Z';
      } else {
        return 'Z - A';
      }
    },
    copywritingFilterRating() {
      if (this.filterRatingss === 'rating') {
        return 'Rating: Tinggi - Rendah';
      } else {
        return 'Rating: Rendah - Tinggi';
      }
    },
    copywritingFilterCreated() {
      if (this.filterCreated === 'newest') {
        return 'Produk: Terbaru - Terlama';
      } else {
        return 'Produk: Terlama - Terbaru';
      }
    },
    selectedBrandList() {
      const selectedBrandList = [];

      let key = 'filterBrandChecked';
      let label = '_id';
      if (this.activeTab === 1) {
        key = 'filterOriginChecked';
        label = 'country_tag_id';
      }

      this.brands.length &&
        this.brands.forEach((brand) => {
          const labelString = brand[label] || '';
          if (this[key].includes(labelString.toString())) {
            selectedBrandList.push(brand);
          }
        });
      return selectedBrandList;
    },
    isFiltered() {
      const query = this.$route.query;
      if (Object.keys(query).length) {
        if (query.brand || query.origins || query.sortby || query.available_for || query.filter_rating) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    tagName() {
      const name = this.$route.params.name || '';
      return name.replace('-', ' ') || '';
    },
    lists_count() {
      return this.$store.state['$_SearchPage'].lists_count;
    },
    lists() {
      return this.$store.state['$_SearchPage'].lists || [];
    },
    list_brands() {
      return this.$store.state.$_SearchPage.brands;
    },
    brand_list() {
      let data = [];
      let key = '';
      if (this.activeTab === 1) {
        data = this.$store.state.$_SearchPage.country;
        key = 'country';
      } else {
        data = this.$store.state.$_SearchPage.brands;
        key = 'name';
      }
      if (this.searchBrand) {
        return data.filter((brand) => {
          const data = brand[key] || '';
          return data.toLowerCase().indexOf(this.searchBrand.toLowerCase()) >= 0;
        });
      } else {
        return data;
      }
    },
    list_country() {
      return this.$store.state.$_SearchPage.country;
    },
    list_categories_parent() {
      return this.$store.state.$_SearchPage.categories;
    },
    trendingSearchData() {
      return this.$store.state.$_SearchHeader.trendingSearch;
    },
    isValidQuery() {
      const lowerCaseQuery = (this.query || '').toLowerCase();
      const word = lowerCaseQuery.split('');
      const result = word.filter((letter) => this.vowelsArray.includes(letter));
      return result.length > 0 ? true : false;
    },
    isShowAnyResult() {
      let isShow = true;
      if (
        !this.isValidQuery &&
        (!this.resultOfBrand || !this.resultOfBrand.length) &&
        (!this.lists || !this.lists.length)
      ) {
        isShow = false;
      }

      return isShow;
    },
    exclusiveAndTrendingTabs() {
      const tabs = JSON.parse(JSON.stringify(this.$store.state.$_SearchHeader.exclusiveAndTrendingTabs));
      // for (const key of Object.keys(tabs)) {
      //   if (!tabs[key].brands.length && !tabs[key].products.length) {
      //     delete tabs[key];
      //   }
      // }
      return tabs;
    },
    exactSearch() {
      return this.$store.state['$_SearchPage'].exactSearch;
    },
  },
  watch: {
    $route(to, from) {
      const isQuerySearchChanged = to.query.query !== from.query.query;
      const isQuerySortbyChanged = to.query.sortby !== from.query.sortby;
      const isQueryPageChanged = to.query.page !== from.query.page;
      const isQueryBrandChanged = to.query.brand !== from.query.brand;
      const isQueryOriginsChanged = to.query.origins !== from.query.origins;
      const isQueryRatingChanged = to.query.filter_rating !== from.query.filter_rating;
      const isQueryAvailableChanged = to.query.available_for !== from.query.available_for;
      const isTagChanged = to.params.name && to.params.name !== from.params.name;

      this.resetFilterDataForFilterProduct();
      this.setfillDataForFilterProduct();

      if (to.fullPath !== from.fullPath) {
        // this.updateRoute(to, from);
        if (this.$route.query && this.$route.query.q) {
          this.$store.dispatch('$_Header/savedSearchHistory', {
            entity_id: null,
            keyword: this.$route.query.q,
          });
        }
      }

      if (isTagChanged) {
        this.$store.commit('setPageInfo', { title: to.params.name });
        this.isLoadingFinishSearchBrand = false;
        this.isLoadingFinishSearchProduct = false;
        this.isLoadingFinishSearchFilterBrand = false;
        this.getAllBrand();
        this.searchProduct();
        return;
      }

      if (to.query.query) {
        this.$store.commit('setPageInfo', { title: to.query.query });
      }

      if (isQuerySearchChanged) {
        this.resetFilter();
        this.searchProduct();
        if (!this.tagName) {
          this.searchBrand();
          this.searchTotalBrand();
        }
        this.getTrendingProducts();
        this.getAllBrand();
        this.$nextTick(() => {
          if (this.$refs.paginationProduct) {
            this.$refs.paginationProduct.regeneratedListPagination();
          }
        });
      }

      if (isQueryBrandChanged) {
        this.searchProduct();
        this.$nextTick(() => {
          if (this.$refs.paginationProduct) {
            this.$refs.paginationProduct.regeneratedListPagination();
          }
        });
      }

      if (isQueryOriginsChanged) {
        this.searchProduct();
        this.$nextTick(() => {
          if (this.$refs.paginationProduct) {
            this.$refs.paginationProduct.regeneratedListPagination();
          }
        });
      }

      if (isQueryRatingChanged) {
        this.searchProduct();
        this.$nextTick(() => {
          if (this.$refs.paginationProduct) {
            this.$refs.paginationProduct.regeneratedListPagination();
          }
        });
      }

      if (isQuerySortbyChanged || isQueryPageChanged) {
        this.searchProduct();
      }

      if (isQueryAvailableChanged) {
        this.searchProduct();
        this.$nextTick(() => {
          if (this.$refs.paginationProduct) {
            this.$refs.paginationProduct.regeneratedListPagination();
          }
        });
      }
    },
    brandId() {
      if (Boolean(this.brandId) === false) {
        this.resetFilterBrand();
      }
    },
    filterBrandChecked() {
      const brandsQuery = this.filterBrandChecked.join();
      if (this.filterBrandChecked && this.filterBrandChecked.length) {
        this.queryString.brand = brandsQuery;
      } else {
        this.queryString.brand = '';
      }
    },
    filterOriginChecked() {
      const originsQuery = this.filterOriginChecked.join();
      if (this.filterOriginChecked && this.filterOriginChecked.length) {
        this.queryString.origins = originsQuery;
      } else {
        this.queryString.origins = '';
      }
    },
    filterRating(newVal, oldVal) {
      if (newVal) {
        this.queryString.filter_rating = newVal;
      } else {
        this.queryString.filter_rating = oldVal;
      }
    },
    filterAvailChecked() {
      const availableForQuery = this.filterAvailChecked.join();
      if (this.filterAvailChecked && this.filterAvailChecked.length) {
        this.queryString.available_for = availableForQuery;
      } else {
        this.queryString.available_for = '';
      }
    },
    dropdownToggleText() {
      const sorting = this.dropdownToggleText.toLowerCase();
      if (sorting) {
        this.queryString.sortby = sorting;
      } else {
        this.queryString.sortby = '';
      }
    },
    activeTab(newVal, OldVal) {
      if (this.screen.isDesktop) {
        const params = {
          limit: 20,
          sort: 'name',
          fields: 'my_soco_sql_id name logo country flag country_tag_id',
        };
        let endpoint = `${Config.MS_SOCO_PUBLIC_API_URL}/brands`;

        if (this.searchBrandFilter) {
          params.filter = {
            name: {
              $regex: '^' + String(this.searchBrandFilter).toLowerCase(),
              $options: 'i',
            },
          };
        } else if (this.query) {
          endpoint = `${Config.MS_CATALOG_API_URL}/products/brands`;
          params.filter = {
            $or: [
              {
                'brand.name': {
                  $regex: String(this.query).toLowerCase(),
                  $options: 'i',
                },
              },
              {
                name: {
                  $regex: String(this.query).toLowerCase(),
                  $options: 'i',
                },
              },
            ],
          };
        }

        axios
          .get(endpoint, {
            params: params,
            headers: { 'SOC-PLATFORM': 'review-web-desktop' },
          })
          .then((response) => {
            if (response.status === 200) {
              if (this.activeTab === 0) {
                this.brands = response.data.data;
              } else {
                const listBrand = response.data.data;
                const result = [];
                const map = new Map();
                for (const item of listBrand) {
                  if (item.country && !map.has(item.country) && item.country_tag_id) {
                    map.set(item.country, true);
                    result.push(item);
                  }
                }
                this.brands = result.sort((a, b) => a.country.localeCompare(b.country));
              }
            }
            this.isLoadingFinishSearchFilterBrand = true;
          })
          .catch((err) => {
            console.error(err);
            this.isLoadingFinishSearchFilterBrand = true;
            this.brands = [];
          });
      }
    },
  },
  mounted() {
    this.$store.commit('$_URI/DESTROY_QUERY_STRING', { q: this.query });
    this.getFilters();
    if (this.$route.query.query) {
      this.$store.commit('setPageInfo', { title: this.$route.query.query });
    }
    if (this.tagName) {
      this.$store.commit('setPageInfo', { title: this.tagName });
    }
    this.getTrendingProducts();
  },
  created() {
    this.setfillDataForFilterProduct();
    this.getAllBrand();
    if (!this.tagName) {
      this.searchBrand();
      this.searchTotalBrand();
      this.fetchExclusiveAndTrendingTabs();
    }
    this.search();
  },
  methods: {
    filtered(filtered) {
      const params = { ...filtered };
      if (params.sort) {
        this.isLoadingFinishSearchProduct = false;
        if (params.sort === 'relevan') {
          this.dropdownChange('Relevan');
        } else {
          this.dropdownChange(params.sort);
        }
      }
    },
    search() {
      const search_query = this.$route.query.query;
      this.$store.commit('$_URI/SET_QUERY_STRING', {
        name: 'q',
        value: search_query,
      });

      return this.$store
        .dispatch('$_SearchPage/search', {
          isLoadMore: false,
          pages: this.pagesName,
          filter: this.pagesTitle,
        })
        .then((response) => {
          if (response.status === 200) {
            let count = response.data.data['add-review_count'] || 0;
            if (
              !count &&
              !this.isShowAnyResult &&
              this.exclusiveAndTrendingTabs[this.onTab] &&
              this.exclusiveAndTrendingTabs[this.onTab].products &&
              this.exclusiveAndTrendingTabs[this.onTab].products.length
            ) {
              count = this.exclusiveAndTrendingTabs[this.onTab].products.length;
            }
            this.$store.commit('$_SearchPage/LISTS_COUNT', count);
          }
          this.isLoadingFinishSearchProduct = true;
          return response;
        })
        .catch((err) => {
          this.isLoadingFinishSearchProduct = true;
          return false;
        });
    },
    setUpdatedProduct(newProduct) {
      this.product = newProduct;
    },
    setRouteQueryString(a, b) {
      const obj_1 = Object.getOwnPropertyNames(a);
      const obj_2 = Object.getOwnPropertyNames(b);

      if (obj_1.length != obj_2.length) {
        return false;
      }

      for (let i = 0; i < obj_1.length; i++) {
        const attr = obj_1[i];
        if (a[attr] !== b[attr]) {
          return false;
        }
      }

      return true;
    },
    showModal() {
      this.$store.commit('toggleModalGlobalState', {
        modalName: 'filterSearch',
      });
    },
    removeSelectedBrand(key) {
      if (this.activeTab === 0) {
        this.filterBrandChecked.splice(key, 1);
      } else {
        this.filterOriginChecked.splice(key, 1);
      }
    },
    applyFilters() {
      let query = Object.assign({}, this.$route.query);

      if (this.queryString.sortby) {
        query = Object.assign(query, { sortby: this.queryString.sortby });
      } else {
        if (query.sortby) {
          delete query.sortby;
        }
      }

      this.getFilters();

      if (this.queryString.brand) {
        query = Object.assign(query, { brand: this.queryString.brand });
      } else {
        this.$store.commit('$_URI/SET_QUERY_STRING', {
          name: 'brands',
          value: '',
        });
        if (query.brand) {
          delete query.brand;
        }
      }

      if (this.queryString.origins) {
        query = Object.assign(query, { origins: this.queryString.origins });
      } else {
        this.$store.commit('$_URI/SET_QUERY_STRING', {
          name: 'origins',
          value: '',
        });
        if (query.origins) {
          delete query.origins;
        }
      }

      if (this.queryString.available_for) {
        query = Object.assign(query, {
          available_for: this.queryString.available_for,
        });
      } else {
        this.$store.commit('$_URI/SET_QUERY_STRING', {
          name: 'available_for',
          value: '',
        });
        if (query.available_for) {
          delete query.available_for;
        }
      }

      query.page = 1;

      if (this.queryString.filter_rating) {
        query = Object.assign(query, {
          filter_rating: this.queryString.filter_rating,
        });
      } else {
        this.$store.commit('$_URI/SET_QUERY_STRING', {
          name: 'rating',
          value: '',
        });
        if (query.filter_rating) {
          delete query.filter_rating;
        }
      }

      if (!this.setRouteQueryString(this.$route.query, query)) {
        this.isLoadingFinishSearchProduct = false;
        this.$router.push({ query: query });
      }
    },
    applyFilterBrand(listBrandVal) {
      if (!listBrandVal) {
        this.searchBrandFilter = '';
        this.queryString.brand_id = '';
        this.getAllBrand();
      }

      if (this.listBrandVal.length) {
        this.queryString.brand_id = listBrandVal;
      }

      this.filterBrandChecked = listBrandVal;
      this.brand_id = this.filterBrandChecked;
      // this.$router.push(`/search?query=${this.query}&page=1&sortby=${this.dropdownToggleText.toLowerCase()}&brand_id=${this.filterBrandChecked}&filter_rating=${this.filterRating}`)
    },
    applyFilterAvailable(listAvailVal) {
      if (listAvailVal) {
        this.filterAvailChecked = listAvailVal;
        this.queryString.available_for = listAvailVal;
      }

      // this.$router.push(`/search?query=${this.query}&page=1&sortby=${this.dropdownToggleText.toLowerCase()}&brand_id=${this.filterBrandChecked}&filter_rating=${this.filterRating}`)
    },
    toggleSortProductByName(sortName) {
      this.filterName =
        this.querySorting === 'name' ? '-name' : this.querySorting === '-name' ? 'name' : this.filterName;

      this.dropdownChange(this.filterName);
    },
    toggleSortProductByRating(sortRating) {
      this.filterRatingss =
        this.querySorting === 'rating' ? '-rating' : this.querySorting === '-rating' ? 'rating' : this.filterRatingss;

      this.dropdownChange(this.filterRatingss);
    },
    toggleSortProductByCreated(sortCreated) {
      this.filterCreated =
        this.querySorting === 'newest' ? 'oldest' : this.querySorting === 'oldest' ? 'newest' : this.filterCreated;

      this.dropdownChange(this.filterCreated);
    },
    dropdownChange(newText) {
      let query = Object.assign({}, this.$route.query);
      const isTriggerNewSorting = newText !== this.dropdownToggleText;
      if (isTriggerNewSorting) {
        this.dropdownToggleText = newText;
        if (this.filterBrandChecked.length || (this.filterRating && this.filterRating !== 'all ratings')) {
          this.sortProduct = this.$options.filters.generateSortingProduct(newText);
        } else {
          this.sortProduct = this.$options.filters.generateSortingProductV2(newText);
        }
        if (this.dropdownToggleText) {
          if (this.queryString.brand) {
            query = Object.assign(query, { brand: this.queryString.brand });
          } else {
            if (query.brand) {
              delete query.brand;
            }
          }

          if (this.queryString.origins) {
            query = Object.assign(query, { origins: this.queryString.origins });
          } else {
            if (query.origins) {
              delete query.origins;
            }
          }

          if (this.queryString.available_for) {
            query = Object.assign(query, {
              available_for: this.queryString.available_for,
            });
          } else {
            if (query.available_for) {
              delete query.available_for;
            }
          }

          query.page = 1;
          this.$store.commit('$_URI/SET_QUERY_STRING', { name: 'skip', value: 0 });

          query.sortby = this.dropdownToggleText.toLowerCase();

          if (this.queryString.filter_rating) {
            query = Object.assign(query, {
              filter_rating: this.queryString.filter_rating,
            });
          } else {
            if (query.filter_rating) {
              delete query.filter_rating;
            }
          }

          if (!this.setRouteQueryString(this.$route.query, query)) {
            this.isLoadingFinishSearchProduct = false;
            this.$router.push({ query: query });
          }
        }
      }
    },
    filterRatingChanged(newRating) {
      this.filterRating = newRating !== 'all ratings' ? newRating : '';
      // this.$router.push(`/search?query=${this.query}&page=1&sortby=${this.dropdownToggleText.toLowerCase()}&brand_id=${this.filterBrandChecked}&filter_rating=${this.filterRating}`)
    },
    getAllBrand() {
      const params = {
        limit: 20,
        sort: 'name',
        fields: 'my_soco_sql_id name logo country flag country_tag_id',
      };
      let endpoint = `${Config.MS_SOCO_PUBLIC_API_URL}/brands`;

      if (this.searchBrandFilter) {
        params.filter = {
          name: {
            $regex: '^' + String(this.searchBrandFilter).toLowerCase(),
            $options: 'i',
          },
        };
      } else if (this.query) {
        endpoint = `${Config.MS_CATALOG_API_URL}/v3/brands/distinct/products`;
        params.filter = {
          keyword: this.query,
          elasticSearch: true,
        };
      }

      axios
        .get(endpoint, {
          params: params,
          headers: { 'SOC-PLATFORM': 'review-web-desktop' },
        })
        .then((response) => {
          if (response.status === 200) {
            this.brands = response.data.data;
            const listBrand = response.data.data;
            const result = [];
            const map = new Map();
            for (const item of listBrand) {
              if (item.country && !map.has(item.country) && item.country_tag_id) {
                map.set(item.country, true);
                result.push(item);
              }
            }
            this.brandscountry = result.sort((a, b) => a.country.localeCompare(b.country));
          }
          this.isLoadingFinishSearchFilterBrand = true;
        })
        .catch((err) => {
          console.error(err);
          this.isLoadingFinishSearchFilterBrand = true;
          this.brands = [];
        });
    },
    getTrendingProducts() {
      this.isLoadingFinishTrendingProducts = true;
      this.$MS_SOCO_PUBLIC_API_URL
        .get(`/products/featured/trending`, {
          params: {
            filter: { is_reviewed: true, trim_response: true },
            fields: 'id name brand images review_stats total_reviews default_category parent_category',
            section: 'TrendingProducts',
            limit: 4,
          },
        })
        .then((response) => {
          if (response.status === 200 && response.data.data) {
            let items = response.data.data;
            items = items.map((res) => {
              if (res.default_combination && !('is_wishlist' in res.default_combination)) {
                res.default_combination.is_wishlist = false;
              }
              return res;
            });
            this.trendingProducts = items;
          } else {
            this.trendingProducts = [];
          }

          this.isLoadingFinishTrendingProducts = false;
        })
        .catch((err) => {
          this.trendingProducts = [];
          this.isLoadingFinishTrendingProducts = true;
        });
    },
    resetFilter() {
      this.filterRating = 'all ratings';
      this.filterAvailChecked = [];
      this.filterBrandChecked = [];
      this.filterOriginChecked = [];
      let url = `/search?query=${this.query}`;
      if (this.tagName) {
        url = `/tag/${this.tagName}?`;
      }
      this.$store.commit('$_URI/DESTROY_QUERY_STRING', { q: this.query });
      if (this.$route.fullPath !== url) {
        this.$router.push(url).catch(() => {});
      }
    },
    resetFilterDataForFilterProduct() {
      this.searchBrandFilter = '';
      this.skipForProduct = 0;
      this.skipForBrand = 0;
      this.filterBrandChecked = [];
      this.filterOriginChecked = [];
    },
    searchingOnFilterBrand(value) {
      this.searchBrandFilter = value;
      this.getAllBrand();
    },
    searchBrand() {
      this.isLoadingFinishSearchBrand = false;
      this.$MS_SOCO_PUBLIC_API_URL
        .get(`brands`, {
          params: {
            filter: {
              $or: [{ name: { $regex: this.query, $options: 'i' } }],
            },
            limit: this.limitForBrand,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            this.resultOfBrand = response.data.data;
          } else {
            this.resultOfBrand = [];
          }
          this.isLoadingFinishSearchBrand = true;
        })
        .catch((err) => {
          this.isLoadingFinishSearchBrand = true;
          this.resultOfBrand = [];
        });
    },

    getFilters() {
      const params = {
        filter: {
          keyword: this.tagName ? this.tagName : this.query,
          is_active_in_review: true,
          is_reviewed: true,
          // get_wishlist:true
        },
        limit: this.limitForProduct || 12,
        skip: this.skipForProduct,
        sort: this.sortProduct,
        // fields: 'id name brand images is_active_in_sociolla is_active_in_lulla is_active_in_review is_wishlist slug is_in_stock review_stats price price_after_discount price_range default_combination available_for_order combination total_reviews default_category price parent_category is_in_stock_lulla is_in_stock_sociolla'
      };

      if (this.queryBrandId || this.$SO.size(this.filterBrandChecked)) {
        this.$store.commit('$_URI/SET_QUERY_STRING', {
          name: 'brands',
          value: this.queryBrandId,
        });
        params.filter['brand.id'] = { $in: this.filterBrandChecked };
      }

      if (this.queryOriginId || this.$SO.size(this.filterOriginChecked)) {
        this.$store.commit('$_URI/SET_QUERY_STRING', {
          name: 'origins',
          value: this.queryOriginId,
        });
        params.filter['brand.country_tag_id'] = {
          $in: this.filterOriginChecked,
        };
      }

      if (this.filterRating && this.filterRating !== 'all ratings') {
        this.$store.commit('$_URI/SET_QUERY_STRING', {
          name: 'rating',
          value: this.filterRating,
        });
        params.filter['review_stats.average_rating'] = {
          $gte: this.filterRating,
          $lte: Number(this.filterRating) + 0.999,
        };
      }

      if (this.$route.query.available_for) {
        this.$store.commit('$_URI/SET_QUERY_STRING', {
          name: 'available_for',
          value: this.$route.query.available_for,
        });
        if (
          this.$route.query.available_for === 'sociolla,lulla' ||
          this.$route.query.available_for === 'lulla,sociolla'
        ) {
          params.filter['is_active_in_sociolla'] = true;
          params.filter['is_active_in_lulla'] = true;
        } else if (this.$route.query.available_for === 'lulla') {
          params.filter['is_active_in_lulla'] = true;
        } else if (this.$route.query.available_for === 'sociolla') {
          params.filter['is_active_in_sociolla'] = true;
        }
      }

      if (this.querySorting) {
        this.$store.commit('$_URI/SET_QUERY_STRING', {
          name: 'sort',
          value: this.querySorting,
        });
      }

      if (this.querySorting === 'relevan' || this.querySorting === 'Relevan') {
        params.filter['is_more_relevant'] = true;
      }

      if (this.tagName) {
        params.filter['is_tag'] = true;
      }

      params.filter.types = ['add-review'];
      params.filter.is_old_request = true;
      params.filter.is_old_response = false;

      return params;
    },
    getUrl() {
      const url = `${Config.MS_CATALOG_API_URL}/v3/search`;
      return url;
    },

    searchProduct() {
      const params = this.getFilters();
      this.isLoadingFinishSearchProduct = false;
      this.$store
        .dispatch('$_SearchPage/search', {
          isLoadMore: false,
          pages: this.pagesName,
          filter: params,
        })
        .finally(() => {
          this.isLoadingFinishSearchProduct = true;
        });
    },

    searchTotalBrand() {
      if (this.query) {
        this.$MS_SOCO_PUBLIC_API_URL
          .get(`brands/count`, {
            params: {
              filter: { keyword: this.query },
            },
          })
          .then((response) => {
            if (response.status === 200) {
              this.totalResultOfBrand = response.data.data;
            } else {
              this.totalResultOfBrand = 0;
            }
          })
          .catch((err) => {
            this.totalResultOfBrand = 0;
          });
      }
    },
    setfillDataForFilterProduct() {
      if (this.queryPage) {
        this.skipForProduct = this.limitForProduct * (this.queryPage - 1);
      }

      if (this.querySorting) {
        this.dropdownToggleText = this.$options.filters.ucwords(this.querySorting);
      }

      if (this.queryBrandId) {
        this.filterBrandChecked = this.queryBrandId.split(',');
        this.activeTab === 0;
      }

      if (this.queryOriginId) {
        this.filterOriginChecked = this.queryOriginId.split(',');
        this.activeTab === 1;
      }

      if (this.queryRating) {
        this.filterRating = this.queryRating;
      }

      if (this.$route.query.available_for) {
        this.filterAvailChecked = this.$route.query.available_for.split(',');
      }
    },
    skipTo(pagination) {
      this.$store.dispatch('$_URI/serialize', { page: pagination.number });
      this.isLoadingFinishSearchProduct = false;
      const newSkip = this.limitForProduct * (pagination.number - 1);
      this.skipForProduct = newSkip;
      this.$store.commit('$_URI/SET_QUERY_STRING', { name: 'skip', value: newSkip });
      let url = `/search?query=${this.query}`;
      if (this.tagName) {
        url = `/tag/${this.tagName}?`;
      }
      url += `&page=${pagination.number}`;
      if (this.dropdownToggleText) {
        url += `&sortby=${this.dropdownToggleText.toLowerCase()}`;
      }
      if (this.filterBrandChecked && this.filterBrandChecked.length) {
        url += `&brand_id=${this.filterBrandChecked}`;
      }
      if (this.filterRating && this.filterRating !== 'all ratings') {
        url += `&filter_rating=${this.filterRating}`;
      }
      this.$router.push(url);
      this.$refs.paginationProduct.regeneratedListPagination();
    },
    async updateRoute(to, from) {
      this.routeUpdated = true;

      if (
        (to.name === 'TagConcern' &&
          from.name === 'TagConcern' &&
          this.pagesName === 'tag-concern' &&
          to.params.name !== from.params.name) ||
        (to.name === 'Search' && from.name === 'Search')
      ) {
        this.resetFilter();
        const res = await this.search();
        if (res.data.success) {
          // const count = await this.searchCount();
          const count = res.data.data['add-review_count'] || 0;
          this.categories(count);
          this.brands(count);
          if (!this.$store.state.$_Screen.isDesktop) {
            this.brandSimilar(count);
          }
        }
        return;
      }

      const search_query = to.query.q ? to.query.q : from.query.q;
      this.$store.commit('$_URI/SET_QUERY_STRING', {
        name: 'q',
        value: search_query,
      });

      this.$store.dispatch('$_URI/serialize', to.query);

      if (to.query.q !== from.query.q && this.pagesName !== 'tag-concern') {
        this.resetFilter();
        const res = await this.search();
        if (res.data.success) {
          // const count = await this.searchCount();
          const count = res.data.data['add-review_count'] || 0;
          this.categories(count);
          this.brands(count);
          if (!this.$store.state.$_Screen.isDesktop) {
            this.brandSimilar(count);
          }
        }
      }
      if (to.query.sort !== from.query.sort || to.query.limit !== from.query.limit) {
        this.search();
        // this.searchCount();
      }

      if (to.query.brands !== from.query.brands || to.query.origins !== from.query.origins) {
        const res = await this.search();
        if (res.data.success) {
          // const count = await this.searchCount();
          const count = res.data.data['add-review_count'] || 0;
          this.categories(count);
        }
      }

      if (to.query.category !== from.query.category) {
        const res = await this.search();
        if (res.data.success) {
          // const count = await this.searchCount();
          const count = res.data.data['add-review_count'] || 0;
          this.brands(count);
          if (!this.$store.state.$_Screen.isDesktop) {
            this.brandSimilar(count);
          }
        }
      }

      if (
        to.query.prices !== from.query.prices ||
        to.query.is_sale !== from.query.is_sale ||
        to.query.rating !== from.query.rating ||
        (from.query.products && to.query.products !== from.query.products) ||
        to.query.tags !== from.query.tags
      ) {
        const res = await this.search();
        if (res.data.success) {
          // const count = await this.searchCount();
          const count = res.data.data['add-review_count'] || 0;
          this.categories(count);
          this.brands(count);
          if (!this.$store.state.$_Screen.isDesktop) {
            this.brandSimilar(count);
          }
        }
      }

      if (to.query.page !== from.query.page) {
        this.search();
        // this.searchCount();
      }
    },
    async fetchExclusiveAndTrendingTabs() {
      return this.$store.dispatch('$_SearchHeader/fetchExclusiveAndTrendingTabs').then((data) => {
        if (data.trending && !data.new_exclusive) {
          this.onTab = 'trending';
        }
        this.initialLoading = false;
      });
    },
    mainImage(src) {
      return this.$options.filters.imageCdn({
        config: this.isDesktop ? 'w=128' : 'w=144',
        image: src,
      });
    },
    imageCover(product) {
      if (!product || !product.images || product.images.length === 0) {
        return '/assets/img/default_img_brand.svg';
      }
      const productImage = product.images.find((e) => e.is_cover) || product.images[0];
      return productImage ? productImage.url : '/assets/img/default_img_brand.svg';
    },
    averageRating(product) {
      return Math.floor(product.review_stats.average_rating);
    },
    trackProduct(product) {
      window.dataLayer.push({
        event: 'productClick',
        ecommerce: {
          click: {
            actionField: { list: 'search' },
            products: [
              {
                name: product.name,
                id: product.id,
              },
            ],
          },
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.card-container {
  display: flex;
  flex-direction: column;
  padding: 5px 0px;
  font-family: 'lato-regular';
}
.card {
  background-color: white;
  padding: 15px 0px;
  // border-radius: 8px;
  // box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 4px;
  gap: 10px;

  .image-container {
    flex-grow: 1;
    display: flex;
    align-self: center;
    place-content: center;
    .image {
      width: 70px;
      height: 70px;
    }
  }

  .details {
    flex-grow: 1;
    max-width: 160px;
    .title {
      font-family: 'lato-bold';
      font-weight: 700;
      font-size: 13px;
      text-transform: uppercase;
      margin-bottom: 5px;
    }

    .subtitle {
      font-size: 12px;
      margin-bottom: 5px;
      display: -webkit-box;
      -webkit-line-clamp: 2; /* Limits text to 2 lines */
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 145px;
    }

    .rating {
      display: flex;
      align-items: center;
      font-size: 0.9rem;
      color: #231f20;

      .stars {
        display: flex;
        gap: 5px;

        .star {
          color: #f2638a;
          font-size: 16px;
        }

        .star-empty {
          color: #ddd;
          font-size: 16px;
        }
      }

      .rating-value {
        margin-left: 5px;
        font: 700 12px 'lato-bold';
      }

      .reviews {
        margin-left: 3px;
        color: #888;
        font: normal 12px 'lato-regular';
      }
    }
  }
}
.group-btn {
  display: flex;
}
.mr-15 {
  margin-right: 15px;
}

.filter-product {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  width: 117px;
  height: 40px;
  margin: 0 auto 24px;
  z-index: 102;
  @include box-shadow(0 2px 4px 0 rgba(0, 0, 0, 0.2));
  @include border-radius(20px);
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #ffffff;
}

.filter-product__img {
  margin-right: 10px;
}

.filter-product__text {
  font: 12px/17px 'lato-bold', sans-serif;
  color: #231f20;
  letter-spacing: normal;
}

.filter-product--active {
  .filter-product__text {
    color: #f384a7;
  }
}

.filter-product--disabled {
  background-color: #f5f5f5;
  pointer-events: none;
}

.search-filter {
  padding: 0 0 16px;
  float: right;
  transform: translateY(45px);
  .tabs {
    align-items: center;
    &:before,
    &:after {
      width: 12px;
      height: 12px;
    }
  }
  .tabs__item {
    font-size: 13px;
    letter-spacing: 0;
    border-color: #f1f1f1;
    &:first-child {
      margin-right: 4px;
      font-weight: 400;
      font-size: 13px;
      letter-spacing: 0;
      text-transform: capitalize;
      & > a {
        padding: 7px 16px;
      }
    }
    & > a {
      color: #8c8582;
      padding: 7px 16px;
    }
    &.tabs__item__search-filter.active > a {
      color: #fff;
    }
    &.tabs__item__search-filter--with-caret > a {
      padding-right: 32px;
    }
    &.tabs__item__search-filter--with-caret:before {
      top: 10px;
    }
    &.tabs__item__search-filter--with-caret:after {
      bottom: 10px;
    }
    & > .tabs__item__search-filter__text-limit {
      font: normal 12px/15px 'lato-regular', sans-serif;
      letter-spacing: normal;
      padding: 9px 12px 9px 0 !important;
      color: #8c8582;
      position: relative;
      top: 1px;
    }
    .tabs__item__search-filter__form-control.show-count {
      height: 32px;
      width: 74px;
    }
    &.tabs__item__search-filter--with-caret.select:before {
      display: none;
    }
    &.tabs__item__search-filter--with-caret.select:after {
      bottom: 12px;
    }
    &.to-right {
      position: absolute;
      right: 0;
    }
  }
}

@media (max-width: 992px) {
  .search-filter {
    padding: 5px 0 16px;
    float: none;
    transform: none;
    .tabs {
      position: relative;
      &:before,
      &:after {
        display: none;
      }
    }
  }
}

@media (max-width: 992px) {
  .search-filter-wrapper {
    height: 32px;
  }
}
</style>
